const updateUpsellUI = (updatedUpsellHtml) => {

  const barWidth = updatedUpsellHtml.querySelector(".threshold_bar .animate")?.style.getPropertyValue("--bar-width");
  const bar = document.querySelector(".threshold_bar .animate");
  if (barWidth && bar) {
      bar.style.setProperty("--bar-width", barWidth)
  }

  const isUpsellComplete = updatedUpsellHtml.querySelector("#cart-upsell .threshold_spend.spend_congrats")?.textContent;
  const updatedUpsellNode = updatedUpsellHtml.querySelector("#cart-upsell");
  const currentUpsellNode = document.querySelector("#mini-cart #cart-upsell");

  if (isUpsellComplete) {
      currentUpsellNode.innerHTML = updatedUpsellNode.innerHTML;
  } else {
    const remainingAmount = updatedUpsellHtml.querySelector("#cart-upsell .threshold_spend")?.innerHTML;
    document.querySelector("#cart-upsell .threshold_spend").innerHTML = remainingAmount;
  }
  
}

const updateMiniCartUI = (updatedMiniCartHtml) => {
  const miniCartTotalPrice = updatedMiniCartHtml.querySelector("#mini-cart-total-price");
  const miniCartContent = updatedMiniCartHtml.querySelector(".mini-cart-content")

  if (miniCartTotalPrice) {
    document.querySelector("#mini-cart-total-price").textContent = miniCartTotalPrice.textContent;
  }

  if (miniCartContent) {
    document.querySelector("#mini-cart .mini-cart-content").innerHTML = miniCartContent.innerHTML;
  }

  updateUpsellUI(updatedMiniCartHtml);

}


const updateTotalCartCount = (updateMiniCartHtml) => {
  const totalCartCount = updateMiniCartHtml.querySelector("[data-total-cart-count]");
  if (totalCartCount) {
    const count = totalCartCount.getAttribute("data-total-cart-count");
    document.querySelector(".cart-item-count").textContent = count;
  }
}



// ------------- Mini cart items quantity change handler---------------

const handleMiniCartItemsQuantityChange = (cartItems) => {
  if (!cartItems || cartItems.length === 0) return;


  cartItems.forEach((btn) => {
      btn.addEventListener("click", () => {
          const input = btn.parentElement.querySelector("input");
          const value = parseInt(input.value);

          const isPlus = btn.classList.contains("plus");
          const key = btn
              .closest(".cart-items-list .cart-item")
              .getAttribute("data-key");

          if (isPlus) {
              const newValue = value + 1;
              updateCartItemQty(key, newValue, btn);
          } else if (value > 1) {
              const newValue = value - 1;
              updateCartItemQty(key, newValue, btn);
          }
      });
  });

  const updateCartItemQty = async (key, quantity, btn) => {
      toggleDisableQtyBtn(btn);
      try {
          const response = await fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                  id: key,
                  quantity,
                  sections: "mini-cart,header",
              }),
          });
          const data = await response.json();

          if (!response.ok) {
              throw new Error(data.message);
          }

          const updatedHtml = data.sections["mini-cart"];
          const updatedHeaderHtml = data.sections["header"];

          const html = document.createElement("div");
          html.innerHTML = updatedHtml;

          const headerHTML = document.createElement("div");
          headerHTML.innerHTML = updatedHeaderHtml;

          // update header cart count
          const headerCartCount = headerHTML.querySelector(".cart-item-count");
          if (headerCartCount) {
              document.querySelector(".cart-item-count").textContent =
                  headerCartCount.textContent;
          }

          // update mini cart
          updateDom(html);
      } catch (err) {
          window.alert(err.message);
      } finally {
          toggleDisableQtyBtn(btn);
      }
  };

  const toggleDisableQtyBtn = (btn) => {
      const element = btn.parentElement;
      const isDisabled = element.classList.contains("disable");
      if (isDisabled) {
          element.classList.remove("disable");
      } else {
          element.classList.add("disable");
      }
  };

  const updateDom = (html) => {
      const cartTotal = html.querySelector("#mini-cart-total-price")?.textContent;
      if (cartTotal) {
          document.querySelector("#mini-cart-total-price").textContent = cartTotal;
      }

      html.querySelectorAll("[data-key]").forEach((updatedCartItem) => {
          const key = updatedCartItem.getAttribute("data-key");

          const DOMCartItem = document.querySelector(`[data-key="${key}"]`);

          if (DOMCartItem) {
              const updatedQuantityInput = updatedCartItem.querySelector(
                  ".cart-item-quantity input"
              );
              if (updatedQuantityInput) {
                  DOMCartItem.querySelector(".cart-item-quantity input").value =
                      updatedQuantityInput.value;
              }

              const updatedPrice =
                  updatedCartItem.querySelector("#mini-cart-item-price")?.textContent;
              if (updatedPrice) {
                  DOMCartItem.querySelector("#mini-cart-item-price").textContent =
                      updatedPrice;
              }
          }
      });

      // update cart upsell
      updateUpsellUI(html);

      // update total cart count
      updateTotalCartCount(html);
  };
}

const handleMiniCartRemoveItem = () => {
  const removeItemBtns = document.querySelectorAll("[data-remove-mini-cart-item]");

  removeItemBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      const key = btn.closest(".cart-item")?.getAttribute("data-key");
      if (!key) throw new Error("Key not found");

      // disable remove item btn
      btn.classList.add("loading");

      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: 0, sections: "mini-cart" }),
      })
      .then(response => response.json())
      .then(data => {
        const updatedMiniCartHtml = data.sections["mini-cart"];
        const wrapper = document.createElement("div");
        wrapper.innerHTML = updatedMiniCartHtml;

        updateMiniCartUI(wrapper);
        handleMiniCartRemoveItem();

        const miniCartItems = document.querySelectorAll("#mini-cart .cart-item-quantity button");
        if (miniCartItems && miniCartItems.length > 0) {
          handleMiniCartItemsQuantityChange(miniCartItems);
        }

        // update total cart count
        updateTotalCartCount(wrapper);

      })
      .finally(() => {
        // enable remove item btn
        btn.classList.remove("loading");
      })
    })
  })
}

// ------------- Add to cart handlder---------------

const handleAddToCart = (context = document) => {

  const notyf = new Notyf({
    duration: 3000,
    position: {
      y: 'top'
    },
    dismissible: true
  });

  context.querySelectorAll("[data-add-to-cart]").forEach(btn => {

      btn.addEventListener("click", async () => {
          const variantElement = btn.closest('[data-variant-id]');
          const variant_id = variantElement ? variantElement.getAttribute('data-variant-id') : null;
          const quantity_input = btn.closest('[data-variant-id]')?.querySelector('input[name="quantity"]')
          let quantity = 1;
          if (quantity_input) {
              quantity = parseInt(quantity_input.value) ?? 1;
          }
          if (!variant_id) return;

          // disable add to cart btn 
          const currentBtn = btn.closest(`[data-variant-id="${variant_id}"]`)?.querySelector('[data-add-to-cart]')
          if (currentBtn) {
              currentBtn.classList.add("disabled", "loading")
          }

          try {
              const response = await fetch("/cart/add.js", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ id: variant_id, quantity, sections: 'mini-cart' }),
              })

              const data = await response.json()
              if (!response.ok) {
                  throw new Error(data.message | "Couldn't add to cart")
              }

              const htmlString = data.sections['mini-cart'];
              const html = document.createElement("div")
              html.innerHTML = htmlString;

              const rawHeaderHTMLString = data.sections["header"];
              const headerHTML = document.createElement("div");
              headerHTML.innerHTML = rawHeaderHTMLString;

              // update mini cart content
              const updatedCartContent = html.querySelector("#mini-cart .mini-cart-content");
              const currentCartContent = document.querySelector("#mini-cart .mini-cart-content");

              if (updatedCartContent && currentCartContent) {
                currentCartContent.innerHTML = updatedCartContent.innerHTML;
              } else {
                console.warn("Mini cart content not found")
              }

              // update mini cart quantity handler
              const miniCartItems = document.querySelectorAll("#mini-cart .cart-item-quantity button");
              if (miniCartItems) {
                handleMiniCartItemsQuantityChange(miniCartItems)
              } else {
                console.warn("Mini cart items not found")
              }
              
              // update mini cart remove item handler
              handleMiniCartRemoveItem();

              // update cart upsell
              updateUpsellUI(html);

              // update total cart value
              const updatedTotalCartValue = html.querySelector("#mini-cart .cart-total .price");
              const currentTotalCartValue = document.querySelector("#mini-cart .cart-total .price");
              if (updatedTotalCartValue && currentTotalCartValue) {
                  currentTotalCartValue.innerHTML = updatedTotalCartValue.innerHTML;
              }

              // update header cart count
              const headerCartCount = headerHTML.querySelector(".cart-item-count");
              if (headerCartCount) {
                document.querySelector(".cart-item-count").textContent = headerCartCount.textContent;
              }

              // open mini cart
              const miniCart = document.querySelector("#mini-cart");
              if (miniCart) {
                miniCart.open();
                console.log("mini cart opened", miniCart)
              }

              // update total cart count
              updateTotalCartCount(html);

          } catch (error) {
            if (notyf) {
              notyf.error({
                message: error.message || toString(error) || "Something went wrong"
              })
            } else {
              window.alert(error.message || toString(error) || "Something went wrong")
              console.warn("Configure Notyf to show error messages")
            }
          } finally {
              currentBtn.classList.remove("disabled", "loading")
          }
      })
  })
}

document.addEventListener('DOMContentLoaded', () => {
  handleAddToCart();

  // Attach quantity handlers to existing mini cart buttons
  const miniCartItems = document.querySelectorAll("#mini-cart .cart-item-quantity button");
  if (miniCartItems && miniCartItems.length > 0) {
    handleMiniCartItemsQuantityChange(miniCartItems);
  }
  handleMiniCartRemoveItem();
});

// --------------------------------------------------

// Embla Carousel

document.addEventListener("DOMContentLoaded", () => {
  class EmblaCarouselManager {
    constructor(carouselElement) {
      // Get the root element
      this.carouselRoot = carouselElement;
      this.viewportNode = this.carouselRoot.querySelector(".embla__viewport");
      this.dotsNode = this.carouselRoot.querySelector(".embla__dots");
      this.prevButton = this.carouselRoot.querySelector(".embla__prev");
      this.nextButton = this.carouselRoot.querySelector(".embla__next");

      this.loop = this.carouselRoot.getAttribute("data-loop") === "true";
      this.axis = this.carouselRoot.getAttribute("data-axis") || "x";
      this.align = this.carouselRoot.getAttribute("data-align") || "start";
      this.slidesToScroll = this.carouselRoot.getAttribute("data-slides-to-scroll") || "auto";
      this.dragFree = this.carouselRoot.getAttribute("data-drag-free") === "true";
      this.autoScrollEnabled = this.carouselRoot.getAttribute("data-auto-scroll") === "true";
      this.autoPlayEnabled = this.carouselRoot.getAttribute("data-auto-play") === "true";
      this.autoPlayDuration = parseInt(this.carouselRoot.getAttribute("data-auto-play-duration"), 10) || 2000;

      this.emblaOptions = {
        loop: this.loop,
        align: this.align,
        axis: this.axis,
        slidesToScroll: this.slidesToScroll === "auto" ? "auto" : parseInt(this.slidesToScroll, 10),
        dragFree: this.dragFree
      };

      this.embla = null;
      this.init();
    }

    init() {
      if (!window.EmblaCarousel) {
        console.warn(
          "Embla Carousel library not found. Please include the script."
        );
        return;
      }

      // Initialize Embla with plugin enabled
      const plugins = [];

      // Add AutoScroll if enabled
      if (this.autoScrollEnabled && window.EmblaCarouselAutoScroll) {
        plugins.push(
          EmblaCarouselAutoScroll({
            speed: 1,
            stopOnMouseEnter: true,
            stopOnInteraction: false
          })
        );
      }

      // Add Autoplay if enabled
      if (this.autoPlayEnabled && window.EmblaCarouselAutoplay) {
        plugins.push(
          EmblaCarouselAutoplay({
            delay: this.autoPlayDuration,
            stopOnMouseEnter: false,
            stopOnInteraction: false
          })
        );
      }

      this.embla = window.EmblaCarousel(this.viewportNode, this.emblaOptions, plugins);

      // Add event listeners
      this.embla.on("init", () => {
        this.updateActiveSlide();
        this.updateButtonStates();
      });
      this.embla.on("select", () => {
        this.updateActiveSlide();
        this.updateButtonStates();
      });
      this.embla.on("reInit", () => {
        this.updateButtonStates();
      });

      if (this.dotsNode) {
        this.setupDots();
        this.embla.on("select", () => this.selectDot());
        this.embla.on("reInit", () => this.setupDots());
      }

      // Setup navigation buttons
      this.setupNavigationButtons();
    }

    setupNavigationButtons() {
      if (this.prevButton) {
        this.prevButton.addEventListener("click", () => {
          this.embla.scrollPrev();
        });
      }

      if (this.nextButton) {
        this.nextButton.addEventListener("click", () => {
          this.embla.scrollNext();
        });
      }
    }

    updateButtonStates() {
      if (!this.embla) return;

      // Check if carousel can scroll in either direction
      const canScrollPrev = this.embla.canScrollPrev();
      const canScrollNext = this.embla.canScrollNext();

      // Update prev button state
      if (this.prevButton) {
        if (canScrollPrev) {
          this.prevButton.classList.remove("disabled");
          this.prevButton.removeAttribute("disabled");
        } else {
          this.prevButton.classList.add("disabled");
          this.prevButton.setAttribute("disabled", "disabled");
        }
      }

      // Update next button state
      if (this.nextButton) {
        if (canScrollNext) {
          this.nextButton.classList.remove("disabled");
          this.nextButton.removeAttribute("disabled");
        } else {
          this.nextButton.classList.add("disabled");
          this.nextButton.setAttribute("disabled", "disabled");
        }
      }
    }

    createDots() {
      if (!this.embla || !this.dotsNode) return;

      // Check if dots already have content
      const existingDots = this.dotsNode.querySelectorAll('.embla__dot');
      if (existingDots.length > 0) {
      existingDots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.embla.scrollTo(index));
      });
      return;
   }

      this.dotsNode.innerHTML = "";
      const numberOfDots = this.embla.scrollSnapList().length;
      if (numberOfDots <= 1) return;

      Array.from({ length: numberOfDots }).forEach((_, index) => {
        const dot = document.createElement("button");
        dot.classList.add("embla__dot");
        dot.addEventListener("click", () => this.embla.scrollTo(index));
        this.dotsNode.appendChild(dot);
      });
    }

    selectDot() {
      if (!this.embla || !this.dotsNode) return;

      const allDots = Array.from(this.dotsNode.children);
      allDots.forEach((dot, index) => {
        dot.classList.toggle(
          "active",
          this.embla.selectedScrollSnap() === index
        );
      });
    }

    setupDots() {
      this.createDots();
      this.selectDot();
    }

    updateActiveSlide() {
      if (!this.embla) return;

      const selectedIndex = this.embla.selectedScrollSnap();
      const slides = this.carouselRoot.querySelectorAll(".embla__slide");

      slides.forEach((slide, index) => {
        if (index === selectedIndex) {
          slide.classList.add("active");
        } else {
          slide.classList.remove("active");
        }
      });
    }

    destroy() {
      if (this.embla) {
        this.embla.destroy();
        this.embla = null;
      }
    }
  }

  // Initialize all carousels on page load
  const carousels = document.querySelectorAll(".embla[data-embla-carousel]");
  carousels.forEach((carousel) => {
    new EmblaCarouselManager(carousel);
  });
  
});


// custom component - Related Products

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');
        const isError = html.querySelector('.msg-on-empty-recommendations');
        if (isError) {
          this.parentElement.remove();
        }

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        // recall add to cart handler
        handleAddToCart();

      })
      .catch((e) => {
        console.error(e);
        this.querySelector(".msg-on-empty-recommendations").textContent = "No related products found";
        this.querySelector(".loader")?.remove()
      });
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}









// Trigger Mini Cart Drawer

const handleTriggerMiniCart = () => {
  const miniCart = document.querySelector("#mini-cart");
  if (!miniCart) throw new Error("Mini cart not found");

  const triggers = document.querySelectorAll("[data-trigger-min-cart]");

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      miniCart.open();
    });
  });

}

document.addEventListener("DOMContentLoaded", () => {
  handleTriggerMiniCart();
});





